var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "max-width": "446",
      "content-class": "white"
    },
    model: {
      value: _vm.alreadyJoin,
      callback: function callback($$v) {
        _vm.alreadyJoin = $$v;
      },
      expression: "alreadyJoin"
    }
  }, [_c('v-layout', {
    staticClass: "text-center px-16px pt-52px pt-md-100px pt-lg-150px pb-40px",
    attrs: {
      "column": "",
      "align-center": ""
    }
  }, [_c('v-img', {
    staticClass: "w-40px w-md-60px mb-20px mb-md-40px md-lg-80px",
    attrs: {
      "src": "/images/event/hunt/icon-warning.svg"
    }
  }), _c('h2', {
    staticClass: "font-size-18 font-size-md-22 font-size-lg-28 lightblue--text mb-40px mb-md-60px mb-lg-100px"
  }, [_vm._v(" 오늘은 이미 참여하셨습니다. "), _c('br'), _vm._v(" 내일 다시 도전해 주세요! ")]), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "to": "/mypage/event",
      "color": "#59B6E5",
      "dark": ""
    }
  }, [_vm._v("마이페이지 바로가기")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }